/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_ExploreInputs */

const en_common_header_explore = /** @type {(inputs: Common_Header_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore`)
};

const zh_common_header_explore = /** @type {(inputs: Common_Header_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览`)
};

/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Common_Header_ExploreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore = /** @type {((inputs?: Common_Header_ExploreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_ExploreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore(inputs)
	return zh_common_header_explore(inputs)
});
export { common_header_explore as "common.header.explore" }